import { AnyFCO } from '../../../core/types/fcoTypes';
import { ComboFilterHierarchyState } from '@lithos/ComboFilter';
import { max, min } from 'lodash';

export const convertTagsToRecord = (data: { key: string; value: string }[]): ComboFilterHierarchyState => {
  return data.reduce<ComboFilterHierarchyState>((acc, { key, value }) => {
    if (!acc[key]) {
      acc[key] = {};
    }
    acc[key][value] = false;
    return acc;
  }, {});
};

export const defaultTagsState = (items: AnyFCO[]) => {
  const rawTags = items.map((source) => source.tags).flat();
  return convertTagsToRecord(rawTags);
};

export const defaultRangeState = <T>(items: T[], key: keyof T) => {
  const values = items.map((item) => (item[key] as unknown[]).length);
  return [0, max(values)] as [number, number];
};

export const defaultDateState = <T>(items: T[], key: keyof T) => {
  const values = items.map((item) => item[key]).flat();
  return [min(values), max(values)] as [Date, Date];
};
